import { Directive, forwardRef } from '@angular/core';
import { AbstractControl, FormControl, NG_VALIDATORS, Validator, ValidatorFn } from '@angular/forms';

import { DateUtil } from 'app/utils';

@Directive({
  selector: '[futureDate][ngModel]',
  providers: [{ provide: NG_VALIDATORS, useExisting: forwardRef(() => FutureDateValidator), multi: true }]
})
export class FutureDateValidator implements Validator {
  public validator: ValidatorFn;

  constructor(private readonly dateUtil: DateUtil) {
    this.validator = this.validateStartDateFactory();
  }

  validate(c: FormControl) {
    return this.validator(c);
  }

  private validateStartDateFactory(): ValidatorFn {
    return (c: AbstractControl) => {
      const dateInput: string = this.dateUtil.slashesToDashes(c.value);
      if (this.dateIsInFuture(dateInput)) {
        return null; // valid
      } else {
        return {
          dateInFuture: false
        };
      }
    };
  }

  private dateIsInFuture(input: string) {
    const today: Date = new Date();
    today.setHours(0, 0, 0, 0);

    const inputDate: Date = new Date(input);
    return inputDate > today;
  }
}



// WEBPACK FOOTER //
// ./src/app/directives/future-date.directive.ts